import React from 'react'
import {api} from 'lib/url'
import DownloadFile from 'organization/DownloadFile'
import {useParams} from 'react-router-dom'

export default function DownloadRoomAssignmentsExport() {
  const {file} = useParams<{file: string}>()
  const url = api(`/room_assignments_export/${file}`)
  return <DownloadFile url={url} />
}
